<app-modal class="address-detail-info-edit" [(visible)]="isCreateVisible" header="EDIT ADDRESS" (visibleChange)="visibleChange($event)" (onCancel)="cancelChanges()">
  <form [formGroup]="formGroup">
    <div class="ui-fluid">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="groupName"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="email"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="phone"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="fax"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="contactName"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="preferredRequestMethod"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="address1"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="address2"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="addressCity"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="addressState"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <form-factory [formGroup]="formGroup" [model]="addressZip"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="isPSR" >
        <form-factory [formGroup]="formGroup" [model]="accessEmrSystemDropdown"></form-factory>
      </div>
      <div class="ui-g-12 ui-md-12 ui-lg-12" *ngIf="showEmrSystem" >
        <form-factory [formGroup]="formGroup" [model]="accessEmrSystem"></form-factory>
      </div>
    </div>
  </form>
  <footer>
    <app-button class="header-button" text="APPLY EDITS" (onClick)="onUpdate()"></app-button>
  </footer>
</app-modal>

<app-confirmation-modal [(visible)]="isConfirmationModalVisible"
                        header="CREATE ADDRESS"
                        (onYes)="continueEdit()"
                        (onCancel)="cancelEdit()" class="text-center">
  These edits will create a new address. All details, including chases, will be moved to this new address.
  Are you sure you want to apply these edits?
</app-confirmation-modal>
